import {
    createEntityAdapter,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit'
import { SchoolEvent } from '../components/Snackbar'
import { RootState } from './store'

export type SchoolEventEntity = {
    id: string
} & SchoolEvent

export const toSchoolEventEntity = (args: [string, SchoolEvent]) => ({
    id: args[0],
    ...args[1],
})

const schoolEventsAdapter = createEntityAdapter<SchoolEventEntity>({
    selectId: (e) => e.id,
    sortComparer: (a, b) =>
        b.timeStamp - a.timeStamp || a.date.localeCompare(b.date),
})

export const initialState = schoolEventsAdapter.getInitialState()

export const schoolEventsSlice = createSlice({
    name: 'schoolEvents',
    initialState,
    reducers: {
        upsertSchoolEvents: (
            state,
            action: PayloadAction<SchoolEventEntity[]>
        ) => {
            schoolEventsAdapter.upsertMany(state, action.payload)
        },
        upsertSchoolEvent: (
            state,
            action: PayloadAction<SchoolEventEntity>
        ) => {
            schoolEventsAdapter.upsertOne(state, action.payload)
        },

        removeSchoolEvent: (state, action: PayloadAction<string>) => {
            schoolEventsAdapter.removeOne(state, action.payload)
        },
        resetSchoolEvents: () => {
            return initialState
        },
    },
})

export const { selectAll: selectAllSchoolEvents, selectIds: selectSchoolEventIds } =
    schoolEventsAdapter.getSelectors((state: RootState) => state.schoolEvents)

export const {
    upsertSchoolEvent,
    upsertSchoolEvents,
    removeSchoolEvent,
    resetSchoolEvents,
} = schoolEventsSlice.actions
export default schoolEventsSlice.reducer
